


















































































import { IWikiCategory } from "@/@types/wiki/wiki-object";
import { Component, Prop, Inject, Vue } from "vue-property-decorator";
import { IWikiType } from "@/@types/wiki/wiki_types";

import ChangeDeliteButtons from "@/components/buttons/change-delite-buttons.vue";
import StandartModal from "@/components/app/standart-modal.vue";
@Component({
  components: { StandartModal, change: ChangeDeliteButtons },
})
export default class WikiCategoryDescription extends Vue {
  @Prop({ type: Array, default: () => [] }) categorys!: Array<IWikiCategory>;
  @Prop({ type: Object, default: null }) category!: IWikiCategory | null;
  @Inject({ from: "categoryFolder", default: null }) readonly cFolder!: string;

  subType = IWikiType.sub;
  mainType = IWikiType.main;

  get mainCategorys(): Array<IWikiCategory> {
    return this.categorys.filter((c) => {
      if (c.type == IWikiType.main) return c;
    });
  }

  get subCategorys(): Array<IWikiCategory> {
    if (!this.category || this.category.type != this.mainType) return [];
    return this.categorys.filter((cat) => {
      if (this.category && cat.mainid && cat.mainid.includes(this.category._id))
        return cat;
    });
  }

  changeMainids(category: IWikiCategory, sub: string): void {
    if (!category.mainid) return;
    const mainid = category.mainid;
    const i = category.mainid.findIndex((id) => id == sub);
    if (i < 0) mainid.push(sub);
    else mainid.splice(i, 1);
    this.$emit("updateCat", { mainid });
  }
}
